import { render, staticRenderFns } from "./waste_input.vue?vue&type=template&id=4f9be762&scoped=true&"
import script from "./waste_input.vue?vue&type=script&lang=js&"
export * from "./waste_input.vue?vue&type=script&lang=js&"
import style0 from "./waste_input.vue?vue&type=style&index=0&id=4f9be762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9be762",
  null
  
)

export default component.exports